import { i18nTranslationHelper } from '@/i18n'

export namespace AssessmentProfile {
  const t = {
    enums: i18nTranslationHelper.getTEnums
  }

  export class Enum {
    static readonly NORMATIVE = new Enum(
      1,
      'NORMATIVE',
      t.enums('assessmentProfile.NORMATIVE.label'),
      t.enums('assessmentProfile.NORMATIVE.description1'),
      t.enums('assessmentProfile.NORMATIVE.description2')
    )

    static readonly CENTRALIZED = new Enum(
      2,
      'CENTRALIZED',
      t.enums('assessmentProfile.CENTRALIZED.label'),
      t.enums('assessmentProfile.CENTRALIZED.description1'),
      t.enums('assessmentProfile.CENTRALIZED.description2')
    )

    static readonly EVOLUTIONARY = new Enum(
      3,
      'EVOLUTIONARY',
      t.enums('assessmentProfile.EVOLUTIONARY.label'),
      t.enums('assessmentProfile.EVOLUTIONARY.description1'),
      t.enums('assessmentProfile.EVOLUTIONARY.description2')
    )

    static readonly EXPANSIVE = new Enum(
      4,
      'EXPANSIVE',
      t.enums('assessmentProfile.EXPANSIVE.label'),
      t.enums('assessmentProfile.EXPANSIVE.description1'),
      t.enums('assessmentProfile.EXPANSIVE.description2')
    )

    static readonly CONSCIOUS = new Enum(
      5,
      'CONSCIOUS',
      t.enums('assessmentProfile.CONSCIOUS.label'),
      t.enums('assessmentProfile.CONSCIOUS.description1'),
      t.enums('assessmentProfile.CONSCIOUS.description2')
    )

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly label: string,
      public readonly description1: string,
      public readonly description2: string
    ) {}
  }

  export const getByName = (name: string | null): Enum => {
    return Object.values(AssessmentProfile.Enum).find(type => type.name === name)
  }
}
